import {
  IDefaultHttpFinancasResponse,
  TDefaultPaginationFinancasHttp
} from "@/core/@types/types";
import { EIntegracoesAPIEnum } from "../../../@types/IntegracoesAPIEnum";

export type TObterWebservicesParams = {
  api?: string;
  inativo?: boolean;
  integrationType?: TIntegrationType;
} & TDefaultPaginationFinancasHttp;

export type TIntegrationType = "API" | "SFTP" | "Webhook";

export type TSelectedIntegration = {
  tipo: TIntegrationType;
  id: string;
  entidade?: number;
};

export type TWebservice = {
  id?: string;
  _id: string;
  nome?: string;
  url?: string;
  status?: string;
  integracao?: string;
  categoria?: string;
  tipo?: string;
  empresa?: string;
  API_Hash?: string;
  Inativo?: boolean;
  Outros?: string;
  Webservice?: string;
  Tipo?: TIntegrationType | string;
  IsSFTP?: boolean;
  VanEntidade?: number;
  UltimoReprocessamento?: string | null;
  UltimaExecucaoEm?: string | null;
};

export type TKeyValue = {
  Id: number;
  Value: string;
};

export type TObterHistoricoIntegracaoParams = {
  serviceId: string;
  data: string;
  client_id: string;
} & TDefaultPaginationFinancasHttp;

export enum EConsoleLogLevel {
  Info = 1,
  Error = 2,
  Detailed = 3
}

export type TConsoleLog = {
  Message: string;
  Level: EConsoleLogLevel;
  Date: string;
};

export type TIntegrationHistoryFile = {
  _id: string;
  Nome: string;
};

export type TArquivoDetalhesIntegracao = {
  _id?: string;
  Nome?: string;
  Arquivos?: TIntegrationHistoryFile[];
  HistoricoReprocessamento?: Array<{
    _id?: string;
    Versao?: string | number;
  }>;
};

export type THistoricoIntegracao = {
  id: string;
  API?: string;
  DataPesquisada: string;
  DataPesquisadaFim?: string;
  Empresa?: string;
  Inicio: string;
  hasDetailLog?: boolean;
  LogDetalhado?: TConsoleLog[];
  SolicitacaoEm: string;
  StatusProcessamento: string;
  Status?: string;
  Fim?: string;
  Usuario: string;
  Arquivos?: TIntegrationHistoryFile[];
  ArquivoId?: string;
  Curls?: string[];
  hasChildren?: boolean;
};

export type TChamarServicoParams = {
  serviceId?: string;
  integrations?: TSelectedIntegration[];
  apiHash?: EIntegracoesAPIEnum;
  apiName?: string;
  empresaId?: string;
  empresa?: string;
  data?: string | Date;
  tipoDeArquivo?: string;
  tipoArquivo?: string;
  selecionarPeriodo?: boolean;
  tipoDeIntegracao?: string;
  tipoIntegracao?: string;
  tipoDePesquisa?: string;
  metadata?: string | string[];
  date?: string | Date;
  Data?: string | Date;
  inicio?: string | Date | null;
  fim?: string | Date | null;
  start?: string | Date;
  end?: string | Date;
  DataInicio?: string | Date | null;
  DataFim?: string | Date | null;
  Inicio?: string | null;
  Fim?: string | null;
  Conta?: string;
  PluggyByRange?: boolean;
  origemSimplificada?: string;
  empresaIsEnabled?: boolean;
  PagHiper?: {
    TipoDePesquisa: string;
  };
  ApiAsaas?: {
    TipoDePesquisa: string;
  };
  ApiMarvin?: {
    Request: string;
  };
  PDVDataSystem?: {
    Request: string;
  };
};

export type TChamarServicoResponse = {
  TipoProcessamento?: string;
  serviceId?: string;
  QuantidadeProcessada?: number;
  QuantidadeComErro?: number;
  Sucessos?: TChamarServicoItemResponse[];
  Erros?: TChamarServicoItemResponse[];
};

export type TChamarServicoItemResponse = {
  Id?: string;
  id?: string;
  ServiceId?: string;
  serviceId?: string;
  Tipo?: TIntegrationType | string;
  tipo?: TIntegrationType | string;
  Entidade?: number;
  entidade?: number;
  Api?: string;
  api?: string;
  Ok?: boolean;
  Error?: string;
  error?: string;
};

export interface PainelDeIntegracaoesGateway {
  obterWebservices(
    params: TObterWebservicesParams
  ): Promise<IDefaultHttpFinancasResponse<TWebservice[]> | undefined>;
  obterListaWebservices(
    params?: TDefaultPaginationFinancasHttp
  ): Promise<IDefaultHttpFinancasResponse<TKeyValue[]> | undefined>;
  obterHistoricoIntegracao(
    params: TObterHistoricoIntegracaoParams
  ): Promise<IDefaultHttpFinancasResponse<THistoricoIntegracao[]> | undefined>;
  obterDetalhesArquivoIntegracao(
    arquivoId: string
  ): Promise<
    IDefaultHttpFinancasResponse<TArquivoDetalhesIntegracao> | undefined
  >;
  baixarArquivosIntegracao(arquivoIds: string[]): Promise<void>;
  deletarIntegracao(
    id: string
  ): Promise<IDefaultHttpFinancasResponse<boolean> | undefined>;
  toggleIntegracao(
    id: string,
    toggle: boolean
  ): Promise<IDefaultHttpFinancasResponse<boolean> | undefined>;
  chamarServico(
    params: TChamarServicoParams,
    destiny: string
  ): Promise<
    IDefaultHttpFinancasResponse<TChamarServicoResponse | boolean> | undefined
  >;
}

export const PainelDeIntegracaoesDi = Symbol("PainelDeIntegracaoesDi");
